// frontend/src/store/slices/companySlice.ts

import { create } from 'zustand'

interface CompanyState {
  currentCompany: any | null
  companies: any[]
  isLoading: boolean
  total: number

  // Actions
  setCurrentCompany: (company: any) => void
  setCompanies: (companies: any[]) => void
  setLoading: (isLoading: boolean) => void
  setTotal: (total: number) => void
  clearCurrentCompany: () => void
}

export const useCompanyStore = create<CompanyState>((set) => ({
  currentCompany: null,
  companies: [],
  isLoading: false,
  total: 0,

  setCurrentCompany: (currentCompany) => set({ currentCompany }),
  setCompanies: (companies) => set({ companies }),
  setLoading: (isLoading) => set({ isLoading }),
  setTotal: (total) => set({ total }),
  clearCurrentCompany: () => set({ currentCompany: null })
}))